
<div class="t-popup popup-patientDetails" [formGroup]="appointmentForm" cdkDrag>
    <div class="t-popup-close"></div>
    <div class="t-popup-frame" style="display: flex; flex-direction:column;">
      <div *ngIf="!event"style="display: flex; width: 50%; float: right">
          
          <button class="search-btn " style="background-color: #6d7cab00;">Select Patient</button>
          <img class="w10" src="assets/images/arr-right.svg"/>
          <button class="search-btn " style="background-color: #6d7cab00;" >Patient Details</button>
          <img class="w10" src="assets/images/arr-right.svg"/>
          <button class="search-btn" style="background-color: #6d7cab00;color: #277382;font-weight: 900;" >Appointment</button>
      </div>
      <button *ngIf="!event" class="t-btn-popup-close" aria-label="close popup" (click)="closeAppointmentModal(false)"></button>
      <div class="t-popup-body">
        <button *ngIf="event" class="t-btn-popup-close" aria-label="close popup" (click)="closeAppointmentModal(false)"></button>
        <h2>{{event? "" :"Set"}} Appointment details</h2>
        
        <!-- Patient Name -->
        <div class="l-flex l-flex-w t-fieldmargin patient-details">
          <div class="w50">
            <div class="l-flex l-flex-c t-field t-field-pad">
              <label> Patient Name </label>
              <i class="t-sep"></i>
              <input type="text" class="t-field-text w100" formControlName="patientName" />
            </div>
          </div>
          <!-- patient phone -->
          <div class="w40">
            <div class="l-flex l-flex-c t-field t-field-pad">
              <label> Patient Mobile </label>
              <i class="t-sep"></i>
              <input type="text" class="t-field-text w100" formControlName="patientMobile" />
            </div>
          </div>
        </div>
  
        <!-- Exam Date Display Only, Consider Adding an Input for Actual Date Selection -->
        <div class="l-flex l-flex-w t-fieldmargin patient-details">
          <div class="w50">
            <div class="l-flex l-flex-c t-field t-field-pad">
              <label> Exam Date </label>
              <i class="t-sep"></i>
              <input [matDatepicker]="appointmentDate"  formControlName="appointmentDate" class="t-field-text w100"/>
              <img src="../../assets/icons/date.svg" (click)="appointmentDate.open()" style='margin-left: -1.8em;'>
              <mat-datepicker #appointmentDate  startView="year"></mat-datepicker>
            </div>
          </div>
  
          <!-- Hour Selection -->
          <div class="w40">
            <div class="l-flex l-flex-c t-field t-field-pad">
              <label>Hour </label>
              <i class="t-sep"></i>
              <select class="t-select w100" formControlName="startHour">
                <option *ngFor="let time of startOptionalsHours" [value]="time">{{time}}</option>
              </select>
            </div>
          </div>
        </div>
  
        <!-- Exam Type  -->
        <div class="l-flex l-flex-w t-fieldmargin patient-details">
          <div class="w50">
            <div class="l-flex l-flex-c t-field t-field-pad">
              <label> Exam Name </label>
              <i class="t-sep"></i>
              <select class="t-select w100" style="padding-left: 1vh;" formControlName="examTypeID">
                <option *ngFor="let e of this.examsTypes" [value]="e.AutoIndex" >{{e.examName}}</option>
              </select>
            </div>
          </div>
          
          <!-- Duration -->
          <div class="w40">
            <div class="l-flex l-flex-c t-field t-field-pad">
              <label>Duration </label>
              <i class="t-sep"></i>
              <input type="text" class="t-field-text w100" formControlName="duration" />
              min
            </div>
          </div>
        </div>
  
        <!-- Comments -->
        <div class="l-flex l-flex-w t-fieldmargin patient-details">
          <div class="w100">
            <div class="l-flex l-flex-c t-field t-field-pad">
              <label> Comments </label>
              <textarea class="t-field-text w100" formControlName="comment"></textarea>
            </div>
          </div>
        </div>
        <div class="l-flex l-flex-w t-fieldmargin patient-details display" style="flex-wrap: inherit;">
          <label class="t-label-top" >

              <input type="radio"  formControlName="SendSMS" [value]="true" class="custom-check -sq" />
              <i class="customInput-display -sq" (click)="appointmentForm.get('SendSMS').setValue(!appointmentForm.get('SendSMS').value)"></i>
              <span>
                  Send SMS Now
              </span>

          </label>
          <label class="t-label-top" >
            <input type="radio"  formControlName="ScheduleSMS" [value]="true" class="custom-check -sq" />
            <i (click)="appointmentForm.get('ScheduleSMS').setValue(!appointmentForm.get('ScheduleSMS').value)" class="customInput-display -sq"></i>
            <span>
                Send SMS Reminder two days before
            </span>

          </label>
         
          
      </div>
  
        
        <div *ngIf="!event" style="display: flex; flex-direction: row;justify-content: space-between; margin-top: 1em;">
          <button class="delete_patieont" matTooltip="ביטול" (click)="closeAppointmentModal(false)" >Cancel</button>
          <button class="save_patieont" matTooltip="שמור תור" (click)="saveAppointment()">Save</button>
        </div>
        <div *ngIf="event" style="display: flex; flex-direction: row;justify-content: space-between; margin-top: 1em;">
          <button class="delete_patieont" matTooltip="מחיקת תור" (click)="showDeleteAlert=true" >Delete</button>

          <div *ngIf="showDeleteAlert" class="t-validation-wrap">
            <button class="t-menu-item is-invalid-left"></button>
            <div class="t-validation-message-left" style="width: 20em; left: -11em; top: -1.5em; font-size: medium;">
              <span style="border-radius: 8px">
                <p style="margin-bottom: 1em;">
                  Are you sure you want to delete this appointment?
                </p>
                <div style="display: flex; justify-content: space-between; margin-left: 1vw; margin-right: 1vw;">
                  <button class="t-menu-item"  (click)="deleteAppointment()">
                    Yes
                  </button>
                  <button class="t-menu-item" (click)="showDeleteAlert = false">
                    No
                  </button>
                </div>
              </span>
            </div>
          </div>
          <button class="save_patieont" matTooltip="עדכון פרטי תור" (click)="updateAppointment()">Close and Update</button>
        </div>
      </div>
    </div>
  </div>
  